import { render, staticRenderFns } from "./HotelLoader.vue?vue&type=template&id=7c5741f6&scoped=true"
import script from "./HotelLoader.vue?vue&type=script&lang=js"
export * from "./HotelLoader.vue?vue&type=script&lang=js"
import style0 from "./HotelLoader.vue?vue&type=style&index=0&id=7c5741f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5741f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardLoader: require('/vercel/path0/components/loaders/CardLoader.vue').default})
